import React from "react";

export function SwitchOff() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="46" height="28" viewBox="0 0 46 28" fill="none">
      <rect x="2" width="44" height="24" rx="12" fill="#E5E9EC" />
      <g filter="url(#filter0_d_switch_off)">
        <circle cx="14" cy="12" r="10" fill="white" />
      </g>
      <defs>
        <filter id="filter0_d_switch_off" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0235294 0 0 0 0 0.0823529 0 0 0 0 0.133333 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export function SwitchOn() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="46" height="28" viewBox="0 0 46 28" fill="none">
      <rect width="44" height="24" rx="12" fill="#148DFD" />
      <g filter="url(#filter0_d_switch_on)">
        <circle cx="32" cy="12" r="10" fill="white" />
      </g>
      <defs>
        <filter id="filter0_d_switch_on" x="18" y="0" width="28" height="28" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0235294 0 0 0 0 0.0823529 0 0 0 0 0.133333 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export function PhoneIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M12.6653 3.99512V6.39612C12.632 6.80018 12.9288 7.15633 13.3322 7.19645H18.6678C19.0712 7.15633 19.368 6.80018 19.3347 6.39612V3.99512" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.3322 24.0034H18.6678" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path fillRule="evenodd" clipRule="evenodd" d="M21.3355 28.0051H10.6644C9.19105 28.0051 7.99664 26.8107 7.99664 25.3373V6.66289C7.99664 5.18952 9.19105 3.99512 10.6644 3.99512H21.3355C22.8089 3.99512 24.0033 5.18952 24.0033 6.66289V25.3373C24.0033 26.8107 22.8089 28.0051 21.3355 28.0051Z" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function DownloadIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M20.7435 14.814L16.0001 19.5573L11.2568 14.814" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.0002 5.32861V19.5572" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M26.6713 21.9277C26.6713 24.5474 24.5477 26.671 21.928 26.671H10.0724C7.45275 26.671 5.3291 24.5474 5.3291 21.9277" stroke="#405261" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
